export class saleOrderItemIdRequest{
    saleOrderItemId:number
    constructor(saleOrderItemId:number){
        this.saleOrderItemId = saleOrderItemId;
    }
}